module.exports = __webpack_public_path__ + "img/insurance.fe0fb9aa.png";